import React from 'react';
import { Icon, IconType, Tooltip } from '@routific/hive';
import styled from 'styled-components';

const IconContainer = styled.span`
  display: inline-flex;
`;

interface Props {
  messages: string[];
}

const WarningIcon: React.FC<Props> = ({ messages }) => {
  const title = messages.length === 1
    ? messages[0]
    : (
      <>
        {messages.map((msg) => (
          <div key={msg}>{msg}</div>
        ))}
      </>
    );

  return (
    <Tooltip title={title} placement="top" arrowPointAtCenter data-testid="warning-icon">
      <IconContainer>
        <Icon icon={IconType.Warning} type="warning" size="small" fill={true} />
      </IconContainer>
    </Tooltip>
  );
};

export default WarningIcon;
